import { render } from "./market-overview.vue?vue&type=template&id=df9c5cb0&scoped=true"
import script from "./market-overview.vue?vue&type=script&lang=ts"
export * from "./market-overview.vue?vue&type=script&lang=ts"

import "./market-overview.vue?vue&type=style&index=0&id=df9c5cb0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-df9c5cb0"

export default script